export const formatDate = (isoString, includeTime = true) => {
  try {
    const date = new Date(isoString);

    const options = includeTime
      ? {
          year: "2-digit",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        }
      : {
          year: "2-digit",
          month: "2-digit",
          day: "2-digit",
        };

    return date.toLocaleString("en-US", options);
  } catch (e) {
    console.log(e);
  }
};
